<template>
    <div class="module-data-statistics-detail">
        <el-row style="padding-bottom:10px">
            <el-col :span="19">
                <el-button
                    @click="$router.go(-1)"
                    size="medium"
                >返回
                </el-button>
                <location-selector hasProvinceAll hasCityAll @change="getModuleStatisticsSchoolList" v-model="locationArray" ref="locSelector"></location-selector>
                <el-select
                    size="medium"
                    placeholder="请选择学校类型"
                    v-model="form.schoolType"
                    @change="handleSchoolTypeChange"
                >
                    <el-option
                        label="全部学校类型"
                        :value="0"
                    ></el-option>
                    <el-option
                        :label="schoolType.name"
                        :value="schoolType.code"
                        :key="schoolTypeIdx"
                        v-for="(schoolType, schoolTypeIdx) in schoolTypeList"
                    ></el-option>
                </el-select>
                <el-date-picker
                    size="medium"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    style="width: 240px;"
                    :clearable="false"
                    v-model="form.dateRange"
                    @change="filterSearch"
                ></el-date-picker>
                <a
                    :href="exportUrl"
                    target="_blank"
                    download="examName"
                >
                    <el-button
                        type="primary"
                        size="medium"
                    >导出
                    </el-button>
                </a>
            </el-col>
            <el-col :span="5">
                <el-input
                    class="search-input search-input--right"
                    size="medium"
                    placeholder="请输入学校名称"
                    icon="el-icon-search"
                    style="width: 100%"
                    clearable
                    v-model="form.schoolName"
                    @change="filterSearch"
                >
                    <el-button
                        slot="append"
                        icon="el-icon-search"
                    ></el-button>
                </el-input>
            </el-col>
        </el-row>

        <div class="tabeWrapper">
            <el-table
                stripe
                border
                fit
                highlight-current-row
                style="width: 100%"
                :height="windowHeight - 215"
                :data="dataList"
            >
                <el-table-column
                    label="id"
                    align="center"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.id}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="所属区域"
                    align="center"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.orgAreaName}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="学校名称"
                    align="center"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="所属经销商"
                    align="center"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.bussinessName}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="学段"
                    align="center"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.type | filterType}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="使用次数"
                    align="center"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.createCount}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="操作"
                >
                    <template slot-scope="scope">
                        <el-button
                            size="small"
                            type="text"
                            @click="gotoUsage(scope.row)"
                        >使用统计
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
                style="margin-top: 20px"
                layout="total, sizes, prev, pager, next, jumper"
                :current-page.sync="pagination.pageNo"
                :page-size="pagination.pageSize"
                :page-sizes="pagination.pageSizes"
                :total="pagination.total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
    /* utils */
    import mixin from "@/mixins/windowResize";
    import {schoolTypeConstants} from "@/utils/constants";

    /* components */
    import LocationSelector from '@/components/LocationSelector';

    /* api */
    import {listAreaByParentCode} from "@/api/kitDataStatistics";
    import {getModuleStatisticsSchoolList} from "@/api/moduleDataStatistics";

    export default {
        mixins: [mixin],
        components: {LocationSelector},
        filters: {
            filterType(val) {
                if (val == 1) {
                    return "幼儿园";
                } else if (val == 2) {
                    return "小学";
                } else if (val == 3) {
                    return "初中";
                } else if (val == 4) {
                    return "高中";
                } else if (val == 5) {
                    return "教育局";
                } else if (val == 6) {
                    return "六年制";
                } else if (val == 7) {
                    return "大中专";
                } else if (val == 9) {
                    return "九年制";
                } else if (val == 10) {
                    return "特殊教育";
                } else if (val == 12) {
                    return "十二年制";
                }
            },
        },
        data() {
            return {
                // 是否正在加载数据 { Boolean }
                tabLoading: false,
                // 表格数据 { Array }
                dataList: [],
                // 分页
                pagination: {
                    pageNo: 1,
                    pageSize: 20,
                    pageSizes: [10, 20, 30, 50],
                    total: 0,
                },
                schoolTypeList: [],
                locationArray: ['0', '0', '0'],

                form: {
                    schoolType: 0,
                    moduleCode: this.$route.query.moduleCode,
                    schoolName: "",
                    dateRange: [
                        this.$moment().date(1).format("YYYY-MM-DD"),
                        this.$moment().format("YYYY-MM-DD"),
                    ],
                },
                exportUrl: "",
            };
        },
        mounted() {
            schoolTypeConstants.forEach((value, key) => {
                this.schoolTypeList.push({
                    name: value,
                    code: key,
                });
            });

            this.listAreaByParentCode().then((data) => {
                if (Array.isArray(data)) {
                    this.provinceList = data;
                    if (data.length) {
                        let js = data.find((item) => item.code == 320000);
                        if (js) {
                            this.form.province = js.code;
                        } else {
                            this.form.province = data[0].code;
                        }
                        this.listAreaByParentCode(this.form.province).then((data) => {
                            if (Array.isArray(data)) {
                                this.cityList = data;
                                if (data.length) {
                                    let nj = data.find((item) => item.code == 320100);
                                    if (nj) {
                                        this.form.city = nj.code;
                                    } else {
                                        this.form.city = data[0].code;
                                    }
                                    this.listAreaByParentCode(this.form.city).then((data) => {
                                        if (Array.isArray(data)) {
                                            this.areaList = data;
                                            this.getModuleStatisticsSchoolList();
                                        }
                                    });
                                }
                            }
                        });
                    }
                }
            });
        },
        methods: {
            // 查询区域
            listAreaByParentCode(parentCode = 156) {
                return new Promise((resolve, reject) => {
                    listAreaByParentCode({
                        parentCode,
                    })
                        .then((data) => {
                            resolve(data);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                });
            },

            getModuleStatisticsSchoolList() {
                let startDate = this.form.dateRange ? this.form.dateRange[0] : "";
                let endDate = this.form.dateRange ? this.form.dateRange[1] : "";
                let orgAreaCode = this.$refs.locSelector.getCode();
                let form = {
                    areaCode: orgAreaCode,
                    schoolName: this.form.schoolName,
                    schoolType: this.form.schoolType,
                    moduleCode: this.form.moduleCode,
                    startDate,
                    endDate,
                    pageNo: this.pagination.pageNo,
                    pageSize: this.pagination.pageSize,
                };
                getModuleStatisticsSchoolList(form)
                    .then((res) => {
                        let _res = res.data;
                        if (_res.code != 200) return Promise.reject(_res.msg);
                        else return _res.data;
                    })
                    .then((data) => {
                        let {dataList, pagination} = data;
                        this.dataList = [...dataList];
                        this.pagination.total = pagination.total;
                        this.exportUrl = `${global.BasePath}structure/modulestatistics/exportModuleStatisticsSchoolList?areaCode=${orgAreaCode}&moduleCode=${form.moduleCode}&schoolType=${form.schoolType}&schoolName=${form.schoolName}&startDate=${startDate}&endDate=${endDate}&token=${this.$store.getters.token}`;
                    });
            },

            handleProvinceChange() {
                this.form.city = "";
                this.form.area = "";
                this.listAreaByParentCode(this.form.province).then((data) => {
                    if (Array.isArray(data)) {
                        this.cityList = data;
                        if (data.length) {
                            this.form.city = data[0].code;
                            this.listAreaByParentCode(this.form.city).then((data) => {
                                if (Array.isArray(data)) {
                                    this.areaList = data;
                                }
                            });
                        }
                    }
                    this.getModuleStatisticsSchoolList();

                });
            },
            handleCityChange() {
                this.form.area = "";
                this.listAreaByParentCode(this.form.city).then((data) => {
                    if (Array.isArray(data)) {
                        this.areaList = data;
                        this.getModuleStatisticsSchoolList();
                    }
                });
            },
            handleAreaChange() {
                this.getModuleStatisticsSchoolList();
            },
            handleSchoolTypeChange() {
                this.getModuleStatisticsSchoolList();
            },

            // 修改 日期范围 / 标题
            filterSearch() {
                this.pagination.pageNo = 1;
                this.getModuleStatisticsSchoolList();
            },
            // 分页 - pageSize 改变
            handleSizeChange(pageSize) {
                this.pagination.pageSize = pageSize;
                this.getModuleStatisticsSchoolList();

            },
            // 分页 - currentPage 改变
            handleCurrentChange(pageNo) {
                this.pagination.pageNo = pageNo;
                this.getModuleStatisticsSchoolList();

            },

            // 详情页
            gotoUsage(item) {
                this.$router.push({
                    path: "usage",
                    query: {
                        statisticsCode: item.moduleCode,
                        startDate: this.form.dateRange[0],
                        endDate: this.form.dateRange[1],
                        id: item.id,
                        moduleName: this.$route.query.moduleName,
                    },
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    .module-data-statistics-detail {
        padding: 12px;

        * {
            box-sizing: border-box;
        }

        .el-select.el-select--medium {
            width: 100px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/dataStatistics/moduleDataStatistics/detail.vue